/**
 * La TVA de la boutique
 */
export class BoutiqueTVA {
    /**
     * Constructeur de l'objet
     * @param row Paramètres du constructeur
     */
    constructor(row) {
        if (row) {
            const { idTVA, libelle, taux } = row;
            this.idTVA = idTVA;
            this.libelle = libelle;
            this.taux = taux;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVUVkEuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJCb3V0aXF1ZVRWQS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxXQUFXO0lBZ0J2Qjs7O09BR0c7SUFDSCxZQUFtQixHQUEwQjtRQUM1QyxJQUFJLEdBQUcsRUFBRTtZQUNSLE1BQU0sRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUVyQyxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztZQUNuQixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztZQUN2QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztTQUNqQjtJQUNGLENBQUM7Q0FDRCJ9